module.exports = __webpack_public_path__ + "static/media/blog-icon.fef6eaed.svg";